import { useMemo } from 'react';
import { useRecoilState } from 'recoil';

import { exhibitionCategoryState, mainStdCategoryState } from '@bo-recoil/category/atom';

export const useCategoryList = () => {
  const [mainCategory] = useRecoilState(mainStdCategoryState);
  const [exhibitionCategory] = useRecoilState(exhibitionCategoryState);

  const standardCategoryList = useMemo(
    () =>
      mainCategory.map((category) => {
        return {
          key: category.standardCategoryNumber,
          label: category.standardCategoryName,
          checked: false,
          disabled: false,
        };
      }),
    [mainCategory]
  );

  const exhibitionCategoryList = useMemo(
    () =>
      exhibitionCategory
        .map((category) => {
          return {
            key: category.commonDetailCode,
            label: category.codeName,
            checked: true,
          };
        })
        .sort((a, b) => a.key - b.key),
    [exhibitionCategory]
  );

  return { standardCategoryList, exhibitionCategoryList };
};
